export default {
  // 购物车列表
  async getCartListAsync(context) {
    if (context.state.cartList.status) {
      return Promise.resolve(1);
    }
    try {
      const res = await this.$http.post('/c/lists.html', { sellerId: '0', priceStatus: '0' });
      if (res.data.status === 1) {
        context.commit('SET_CART_LIST', res.data);
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  async editCartAsync(context, payload) {
    try {
      const res = await this.$http.post('/c/edit.html', payload);
      if (res.data.status === 1) {
        context.commit('RESET_CART_LIST');
        await context.dispatch('getCartListAsync');
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  async deleteCartAsync(context, payload) {
    try {
      const res = await this.$http.post('/c/delete.html', payload);
      if (res.data.status === 1) {
        context.commit('RESET_CART_LIST');
        await context.dispatch('getCartListAsync');
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // 生成订单
  async placeOrderAsync(context, payload) {
    try {
      const res = await this.$http.post('/sor/add.html', payload);
      if (res.data.status === 1) {
        context.commit('RESET_CART_LIST');
        context.commit('center/RESET_ORDER_LIST', 'all', { root: true });
        context.commit('center/RESET_ORDER_LIST', 'unpayed', { root: true });
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Success',
          },
          { root: true },
        );
        return Promise.resolve({
          id: res.data.id,
          orderNo: res.data.orderNo,
        });
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
  // Paypal付款
  async payNowAsync(context, payload) {
    try {
      const res = await this.$http.post('/p/pay_success.html', payload);
      if (res.data.status === 1) {
        context.commit(
          'TOGGLE_SNACKBAR',
          {
            type: 'success',
            text: 'Payment completed',
          },
          { root: true },
        );
        context.commit('center/RESET_ORDER_LIST', 'all', { root: true });
        context.commit('center/RESET_ORDER_LIST', 'unpayed', { root: true });
        return Promise.resolve(res.data.status);
      }
      throw new Error(res.data.info);
    } catch (error) {
      context.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: error.message,
        },
        { root: true },
      );
      return Promise.reject(error);
    }
  },
};
